/**
 * Admin
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import {  HttpHeaders, HttpParams,
          HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { EeHttpLogPagination } from '../model/eeHttpLogPagination';
import { LogPagination } from '../model/logPagination';
import { TgLogPagination } from '../model/tgLogPagination';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


import { JtHttp, HttpResponse } from '../../JtHttp';

@Injectable()
export class LogsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: JtHttp, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param orderBy 
     * @param orderByDesc 
     * @param page 
     * @param size 
     * @param userId 
     * @param responseStatusCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminLogsHttpLogsAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, userId?: number, responseStatusCode?: number, observe?: 'body', reportProgress?: boolean): Observable<EeHttpLogPagination>;
    public apiAdminLogsHttpLogsAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, userId?: number, responseStatusCode?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EeHttpLogPagination>>;
    public apiAdminLogsHttpLogsAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, userId?: number, responseStatusCode?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EeHttpLogPagination>>;
    public apiAdminLogsHttpLogsAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, userId?: number, responseStatusCode?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orderBy !== undefined && orderBy !== null) {
            queryParameters = queryParameters.set('orderBy', <any>orderBy);
        }
        if (orderByDesc !== undefined && orderByDesc !== null) {
            queryParameters = queryParameters.set('orderByDesc', <any>orderByDesc);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (userId !== undefined && userId !== null) {
            queryParameters = queryParameters.set('userId', <any>userId);
        }
        if (responseStatusCode !== undefined && responseStatusCode !== null) {
            queryParameters = queryParameters.set('responseStatusCode', <any>responseStatusCode);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<EeHttpLogPagination>('get',`${this.basePath}/api/Admin/Logs/HttpLogsAll`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param orderBy 
     * @param orderByDesc 
     * @param page 
     * @param size 
     * @param code 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminLogsLogsAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, code?: string, observe?: 'body', reportProgress?: boolean): Observable<LogPagination>;
    public apiAdminLogsLogsAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, code?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LogPagination>>;
    public apiAdminLogsLogsAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, code?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LogPagination>>;
    public apiAdminLogsLogsAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, code?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orderBy !== undefined && orderBy !== null) {
            queryParameters = queryParameters.set('orderBy', <any>orderBy);
        }
        if (orderByDesc !== undefined && orderByDesc !== null) {
            queryParameters = queryParameters.set('orderByDesc', <any>orderByDesc);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (code !== undefined && code !== null) {
            queryParameters = queryParameters.set('code', <any>code);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<LogPagination>('get',`${this.basePath}/api/Admin/Logs/LogsAll`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param orderBy 
     * @param orderByDesc 
     * @param page 
     * @param size 
     * @param code 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminLogsTgLogsAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, code?: string, observe?: 'body', reportProgress?: boolean): Observable<TgLogPagination>;
    public apiAdminLogsTgLogsAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, code?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TgLogPagination>>;
    public apiAdminLogsTgLogsAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, code?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TgLogPagination>>;
    public apiAdminLogsTgLogsAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, code?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orderBy !== undefined && orderBy !== null) {
            queryParameters = queryParameters.set('orderBy', <any>orderBy);
        }
        if (orderByDesc !== undefined && orderByDesc !== null) {
            queryParameters = queryParameters.set('orderByDesc', <any>orderByDesc);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (code !== undefined && code !== null) {
            queryParameters = queryParameters.set('code', <any>code);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TgLogPagination>('get',`${this.basePath}/api/Admin/Logs/TgLogsAll`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
